import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class PhotoItemId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): PhotoItemId {
    return new PhotoItemId(value);
  }
}
